import SplitBars from './Stacked'
import PieChart from './Pie'
import Chart from './Standard'

export default Chart
export { PieChart, SplitBars }
